import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInputForm: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="input-form, text-area, prompt, rename"><path d="M9 21H7.5V3H9V21ZM6 18H5.75C3.67893 18 2 16.3211 2 14.25V9.75C2 7.67893 3.67893 6 5.75 6H6V18ZM18.25 6C20.3211 6 22 7.67893 22 9.75V14.25C22 16.3211 20.3211 18 18.25 18H10.5V6H18.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconInputForm;
